import { DialogOpenEvent } from '@theme/dialog';
import { loadDeferredComponentStyles } from '@theme/deferred-styles';

/**
 * @param {HTMLElement} modal
 */
function focusVehicleSection(modal) {
  const vehicle = modal.querySelector('[data-search-modal-vehicle]');
  requestAnimationFrame(() => {
    if (vehicle instanceof HTMLElement) {
      vehicle.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    const year = modal.querySelector('[data-vehicle-input="year"]');
    if (year instanceof HTMLSelectElement) year.focus();
  });
}

function initSearchModalOpenBehavior() {
  const modal = document.querySelector('#search-modal');
  if (!(modal instanceof HTMLElement)) return;

  if ('showDialog' in modal && typeof /** @type {{ showDialog: () => void }} */ (modal).showDialog === 'function') {
    const originalShowDialog = /** @type {{ showDialog: () => void }} */ (modal).showDialog.bind(modal);
    /** @type {{ showDialog: () => void }} */ (modal).showDialog = () => {
      loadDeferredComponentStyles('searchModal')
        .catch(() => {})
        .then(() => originalShowDialog());
    };
  }

  modal.addEventListener(DialogOpenEvent.eventName, () => {
    focusVehicleSection(modal);
  });

  document.addEventListener(
    'click',
    (event) => {
      const opener = event.target instanceof Element ? event.target.closest('[data-search-modal-opener]') : null;
      if (!opener) return;
      event.preventDefault();

      if ('showDialog' in modal && typeof /** @type {{ showDialog: () => void }} */ (modal).showDialog === 'function') {
        /** @type {{ showDialog: () => void }} */ (modal).showDialog();
      }
    },
    true
  );
}

document.addEventListener('DOMContentLoaded', initSearchModalOpenBehavior);
